import routes from '../routes';

export const APP_URL = 'https://cupcakebday.com';
export const PRIVACY_POLICY_URL = `${APP_URL}${routes.privacyPolicy}`;
export const TERMS_OF_SERVICE_URL = `${APP_URL}${routes.termsOfService}`;
export const PRIVACY_EMAIL = 'cupcake-support@googlegroups.com';
